import { render, staticRenderFns } from "./Mayday.vue?vue&type=template&id=4230376d&"
import script from "./Mayday.vue?vue&type=script&lang=js&"
export * from "./Mayday.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports